module.exports = __webpack_public_path__ + "img/papules.6afad95c.svg";